import React from "react"

import Layout from "../components/layout"
import Login from "../components/login"

import SEO from "../components/seo"

const IndexPage = () => (
  <Layout>
    <SEO title="Login" />
    <Login />
    <div css={`display:flex;justify-content:center;padding:2rem;`}>
      <a href="/admin/#/" css={`text-align:center;color:black;text-decoration:underline;`}>Admin Section</a>
    </div>
  </Layout>
)

export default IndexPage
